<template>
    <v-card outlined class="borderTable">
        <v-card-title class="secondaryMain">
            <h5 class="lightenPrimary--text">{{ title }}</h5>
            <v-spacer />
            <v-text-field
                :value="search"
                dense
                prepend-inner-icon="mdi-magnify"
                label="Buscar..."
                hide-details="auto"
                clearable
                single-line
                dark
                style="max-width: 350px"
                @input="$emit('update:search', $event)"
            />
        </v-card-title>
        <v-card-text class="white pa-2">
            <v-data-table
                multi-sort
                dense
                :headers="headers"
                :loading="loadingReservas"
                :items="_lista"
                item-key="_id"
                caption
                class="elevation-1"
                :items-per-page="itemsPerPage"
                :search="search"
                @update:options="onTableOptions"
            >
                <template v-slot:[`item._id`]="{ item }">
                    <v-row class="d-flex flex-column align-center ma-2">
                        <v-chip :color="item.finalizado === 1 ? 'red' : 'green'" dark> {{ item._id }} </v-chip>
                        <b v-if="item.idOrdenCompra" class="bold green--text">OC_{{ item.idOrdenCompra }}</b>
                        <b v-if="item.numeroComprobante" class="bold green--text">{{ item.numeroComprobante }}</b>
                        <v-chip v-if="item.anticiposPendientes" small color="orange darken-2" dark class="mt-1">
                            {{ item.anticiposPendientes }} anticipo(s) por deducir
                        </v-chip>
                    </v-row>
                </template>
                <template v-slot:[`item.descEstado`]="{ item }" v-if="[2, 4].includes(user['idBussines'])">
                    <div class="d-flex flex-column align-center">
                        <v-chip v-if="item.descEstado" :color="colorEstado(item.idEstado)" dark> {{ item.descEstado }} </v-chip>
                        <span v-if="item.fechaEstado" class="caption grey--text text--darken-1 mt-1">{{ item.fechaEstado }}</span>
                    </div>
                </template>
                <template v-slot:[`item._full_name`]="{ item }">
                    <div class="d-flex flex-column">
                        <span>{{ item._full_name }}</span>
                        <span class="caption grey--text text--darken-1">{{ item.numeroDocumento }}</span>
                    </div>
                </template>
                <template v-slot:[`item.UserAssignment`]="{ item }">
                    <v-row class="d-flex flex-column align-center ma-2">
                        <v-chip v-if="item.UserAssignment"> {{ item.UserAssignment }} </v-chip>
                        <b v-if="item.web_online"> {{ item.web_online }} </b>
                    </v-row>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="indigo lighten-2" small @click="openHistorialEstado(item)">mdi-history</v-icon>
                        </template>
                        <span>Historial Estados</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="user.idBussines != 1">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="orange darken-1" small @click="openDatosEnvio(item)">mdi-truck-delivery</v-icon>
                        </template>
                        <span>Datos de Envío</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.estado != 1">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-bind="attrs" v-on="on" @click="editItem(item)">
                                <v-icon small color="green lighten-2">mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-bind="attrs" v-on="on" @click="showItem(item)">
                                <v-icon color="blue lighten-2" small>mdi-file-find</v-icon>
                            </v-btn>
                        </template>
                        <span>Ver</span>
                    </v-tooltip>

                    <v-menu bottom left offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-bind="attrs" v-on="on">
                                <v-icon small>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="createOrden(item)">
                                <v-list-item-icon><v-icon small>mdi-factory</v-icon></v-list-item-icon>
                                <v-list-item-title>Orden de Pedido</v-list-item-title>
                            </v-list-item>

                            <v-list-item v-if="item.estado == 1" @click="printReservation(item)">
                                <v-list-item-icon><v-icon small>mdi-cloud-print</v-icon></v-list-item-icon>
                                <v-list-item-title>Imprimir Ticket</v-list-item-title>
                            </v-list-item>

                            <v-list-item v-if="item.estado == 1 && (optionalRole.isAdmin || [2, 3].includes(user.id_role))" @click="activeTicket(item)">
                                <v-list-item-icon><v-icon small>mdi-lightbulb-on</v-icon></v-list-item-icon>
                                <v-list-item-title>Activar</v-list-item-title>
                            </v-list-item>

                            <v-divider v-if="item.estado != 1 && item.finalizado != 1"></v-divider>

                            <v-list-item v-if="item.finalizado != 1" @click="openDialog3(item)">
                                <v-list-item-icon><v-icon small>mdi-file-outline</v-icon></v-list-item-icon>
                                <v-list-item-title>Generar Comprobante</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="item.atributos?.url_pdf_doc || item.atributos?.facturas?.length" @click="abrirComprobantes(item)">
                                <v-list-item-icon><v-icon small>mdi-file-document-outline</v-icon></v-list-item-icon>
                                <v-list-item-title>Ver Comprobantes PDF</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="item.atributos?.urlGuiaRemision" @click="windowOpen(item.atributos.urlGuiaRemision)">
                                <v-list-item-icon><v-icon small>mdi-truck</v-icon></v-list-item-icon>
                                <v-list-item-title>Guía Remisión</v-list-item-title>
                            </v-list-item>

                            <v-divider v-if="user.idBussines === 4 && item.finalizado != 1"></v-divider>

                            <v-list-item v-if="user.idBussines === 4 && item.finalizado != 1" @click="openCopiarCuba(item)">
                                <v-list-item-icon><v-icon small color="blue">mdi-content-copy</v-icon></v-list-item-icon>
                                <v-list-item-title class="blue--text">Copiar a Cuba</v-list-item-title>
                            </v-list-item>

                            <v-divider v-if="optionalRole.isAdmin && item.estado != 1 && item.finalizado != 1"></v-divider>

                            <v-list-item v-if="optionalRole.isAdmin && item.estado != 1 && item.finalizado != 1" @click="openDelete(item)">
                                <v-list-item-icon><v-icon small color="red">mdi-delete</v-icon></v-list-item-icon>
                                <v-list-item-title class="red--text">Eliminar</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
        </v-card-text>
        <v-dialog v-model="dialog2" max-width="300px">
            <v-card>
                <v-card-title class="grey lighten-3">
                    <h5>¿Desea eliminar el ticket {{ itemSelected.id }}?</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn color="primary" text @click="dialog2 = false">atras</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="loading2" @click="deleteItem">ELIMINAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Paso 1 de la emisión: comprobante completo o anticipo -->
        <v-dialog persistent v-model="dialogTipoEmision" max-width="420px">
            <v-card>
                <v-card-title class="grey lighten-3">
                    <v-col cols="12">
                        <h6>¿Cómo desea emitir el comprobante de la venta {{ itemSelected._id }}?</h6>
                    </v-col>
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-alert dense text type="info" class="mb-4">
                        Completa: factura todos los productos. Anticipo: cobra por adelantado un monto que después se descuenta en la factura final.
                    </v-alert>
                    <v-alert v-if="anticiposDisponibles.length > 0" dense text type="warning" class="mb-4">
                        Anticipos pendientes: {{ anticiposDisponibles.length }} por {{ monedaSimbolo }} {{ totalAnticiposPendientes.toFixed(2) }}
                    </v-alert>
                    <v-btn block outlined color="primary" class="mb-3" @click="elegirEmision(false)">Factura completa</v-btn>
                    <v-btn block color="primary" @click="elegirEmision(true)">Factura de anticipo</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="dialogTipoEmision = false">atras</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialog3" max-width="420px">
            <form @submit.prevent="comprobante">
                <v-card>
                    <v-card-title class="grey lighten-3">
                        <v-col cols="12">
                            <h6>
                                ¿Desea proceder con la emision de la {{ itemSelected.idTipoComprobante === 1 ? 'FACTURA' : 'BOLETA' }} <br />
                                a
                                {{ itemSelected.full_name }} ?
                            </h6>
                        </v-col>
                    </v-card-title>
                    <v-card-text>
                        <div class="primary text-center ma-4" color="primary">
                            <span class="white--text">TOTAL A PAGAR:&nbsp;&nbsp;{{ monedaSimbolo }} {{ montoBaseComprobante.toFixed(2) }}</span>
                        </div>
                        <!-- Factura de anticipo: un solo ítem, resuelto del catálogo del tenant
                             (producto NIU o servicio ZZ); la vendedora edita el detalle y el monto. -->
                        <v-card v-if="esEmisionAnticipo" outlined class="ma-4 mt-0">
                            <v-card-text class="pb-2">
                                <v-row dense>
                                    <v-col cols="12" sm="4">
                                        <v-select
                                            outlined
                                            dense
                                            v-model="itemAnticipoSeleccionadoId"
                                            :items="opcionesItemAnticipo"
                                            item-text="etiqueta"
                                            item-value="internal_id"
                                            label="Ítem del anticipo *"
                                            :loading="cargandoItemsAnticipo"
                                            :disabled="cargandoItemsAnticipo || opcionesItemAnticipo.length <= 1"
                                            no-data-text="Sin ítem de anticipo"
                                            :hint="itemAnticipoSeleccionado ? itemAnticipoSeleccionado.internal_id : ''"
                                            persistent-hint
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="8">
                                        <v-text-field
                                            outlined
                                            dense
                                            v-model="anticipoDetalle"
                                            label="Detalle *"
                                            :rules="[(v) => !!String(v || '').trim() || 'Ingrese el detalle del anticipo']"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            outlined
                                            dense
                                            v-model="anticipoMonto"
                                            label="Monto del anticipo *"
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            @keypress="isNumber"
                                        />
                                    </v-col>
                                </v-row>
                                <p v-if="errorItemsAnticipo" class="caption error--text mb-0">{{ errorItemsAnticipo }}</p>
                            </v-card-text>
                        </v-card>
                        <!-- Factura final: descuenta los anticipos pendientes de la venta. -->
                        <v-card v-if="!esEmisionAnticipo && anticiposDisponibles.length > 0" outlined class="ma-4 mt-0">
                            <v-card-text class="pb-2">
                                <div class="caption grey--text text--darken-1 mb-2">Anticipos pendientes de esta venta</div>
                                <v-checkbox
                                    v-for="anticipo in anticiposDisponibles"
                                    :key="anticipo.numero"
                                    dense
                                    hide-details
                                    class="mt-0"
                                    :value="anticipo.numero"
                                    v-model="anticiposSeleccionados"
                                    :label="`${anticipo.numero} — ${monedaSimbolo} ${Number(anticipo.total).toFixed(2)}`"
                                ></v-checkbox>
                            </v-card-text>
                        </v-card>
                        <!-- Pagos de la venta: viajan y se asocian a este comprobante solo los marcados. -->
                        <v-card v-if="pagosVenta.length > 0" outlined class="ma-4 mt-0">
                            <v-card-text class="pb-2">
                                <div class="caption grey--text text--darken-1 mb-2">Pagos de la venta — marque los que se asocian a esta factura</div>
                                <v-checkbox
                                    v-for="pago in pagosVenta"
                                    :key="pago.id"
                                    dense
                                    hide-details
                                    class="mt-0"
                                    v-model="pagosSeleccionados"
                                    :value="Number(pago.id)"
                                    :disabled="!!pago.idExternal"
                                    :label="etiquetaPago(pago)"
                                ></v-checkbox>
                            </v-card-text>
                        </v-card>
                        <v-row dense class="pt-4 ma-0">
                            <v-col cols="12">
                                <v-autocomplete
                                    outlined
                                    dense
                                    v-model="itemSelected.idTipoComprobante"
                                    v-validate="'required'"
                                    :items="tipoComprobanteFact"
                                    item-text="descripcion"
                                    placeholder="Tipo Comprobante"
                                    item-value="id"
                                    label="Tipo Comprobante"
                                    data-vv-name="itemSelected.idTipoComprobante"
                                    data-vv-as="Tipo"
                                    required
                                    @change="onChangeTipoComprobante"
                                />
                            </v-col>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-autocomplete
                                        class="required"
                                        outlined
                                        dense
                                        v-model="itemSelected.idCondicionPago"
                                        item-text="value"
                                        item-value="id"
                                        :items="condicionPago"
                                        label="Condicion de pago"
                                        v-validate="'required'"
                                        required
                                    />
                                </v-col>
                            </v-row>
                            <!-- El tipo de cambio siempre visible: a veces el API no lo trae y el
                                 usuario tiene que poder verlo y actualizarlo. En dólares es editable
                                 y obligatorio (define el exchange_rate y el monto de la detracción,
                                 que se deposita en soles). En soles queda fijo en 1: un comprobante
                                 en soles con otro tipo de cambio sería inconsistente. -->
                            <v-col cols="12">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="tipoCambioEmision"
                                    :label="itemSelected.idTipoMoneda == 2 ? 'Tipo de cambio *' : 'Tipo de cambio'"
                                    type="number"
                                    step="0.001"
                                    min="0"
                                    placeholder="Ej. 3.5"
                                    :disabled="itemSelected.idTipoMoneda != 2"
                                    :hint="itemSelected.idTipoMoneda == 2 ? 'Necesario para comprobantes en dólares' : 'En soles el tipo de cambio es 1'"
                                    persistent-hint
                                ></v-text-field>
                            </v-col>
                            <v-row class="ma-auto" v-if="itemSelected.idCondicionPago == 2">
                                <v-row v-for="(item, index) in cuotas" :key="index">
                                    <v-col cols="5" sm="5">
                                        <v-menu v-model="item.menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    dense
                                                    outlined
                                                    v-model="item.date"
                                                    label="Fecha de Pago"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker v-model="item.date" locale="es" @input="item.menu = false" />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="5" sm="5">
                                        <v-text-field
                                            dense
                                            outlined
                                            v-validate="'required'"
                                            v-model="item.importe"
                                            class="required"
                                            required
                                            label="Saldo Recibido"
                                            @keypress="isNumber"
                                        />
                                    </v-col>
                                    <v-col cols="2" sm="2" class="pt-6">
                                        <v-row v-if="!(index == 0)">
                                            <v-btn icon large @click="deleteCuota(index)">
                                                <v-icon color="primary" small>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" sm="2">
                                    <v-btn icon color="indigo" @click="pushCuotas()">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-col cols="12" v-if="[2, 4].includes(this.user.idBussines)">
                                <v-autocomplete
                                    outlined
                                    dense
                                    v-model="itemSelected.idUserAssignment"
                                    v-validate="'required'"
                                    :items="listUserSede"
                                    item-text="nombres"
                                    placeholder="Vendedor"
                                    item-value="id"
                                    label="Vendedor"
                                    data-vv-name="itemSelected.idUserAssignment"
                                    data-vv-as="Vendedor"
                                    required
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3" sm="12">
                                <v-autocomplete
                                    outlined
                                    dense
                                    clas="required"
                                    v-model="itemSelected.isEmailSelected"
                                    item-text="value"
                                    item-value="id"
                                    :items="enviarCorreo"
                                    label="¿Enviar a Correo?"
                                    v-validate="'required'"
                                    required
                                />
                            </v-col>
                        </v-row>
                        <!-- Condiciones especiales: solo para Factura y mutuamente excluyentes -->
                        <v-row v-if="itemSelected.idTipoComprobante == 1">
                            <v-col cols="12">
                                <v-divider class="my-1"></v-divider>
                                <v-checkbox
                                    dense
                                    hide-details
                                    class="mt-0"
                                    v-model="conDetraccion"
                                    :disabled="conRetencion"
                                    label="Operación sujeta a detracción"
                                ></v-checkbox>
                            </v-col>
                            <template v-if="conDetraccion">
                                <v-col cols="12">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        v-model="detraccionTipo"
                                        :items="tipoDetraccion"
                                        item-text="descripcion"
                                        item-value="id"
                                        label="Bien o servicio sujeto a detracción"
                                    >
                                        <template v-slot:item="{ item }">
                                            <span>{{ item.descripcion }} - {{ item.porcentaje }}%</span>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <span>{{ item.descripcion }} - {{ item.porcentaje }}%</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-alert dense text type="info" class="mb-0">
                                        Detracción {{ detraccionPorcentaje }}%: <strong>S/. {{ montoDetraccion }}</strong>
                                        <br />
                                        Neto a pagar: <strong>{{ monedaSimbolo }} {{ montoNetoDetraccion }}</strong>
                                    </v-alert>
                                </v-col>
                            </template>
                            <v-col cols="12">
                                <v-checkbox
                                    dense
                                    hide-details
                                    class="mt-0"
                                    v-model="conRetencion"
                                    :disabled="conDetraccion"
                                    label="Cliente es agente de retención (retención IGV 3%)"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" v-if="conRetencion">
                                <v-alert dense text type="info" class="mb-0">
                                    Retención 3%: <strong>{{ monedaSimbolo }} {{ montoRetencion }}</strong>
                                    <br />
                                    Neto a pagar: <strong>{{ monedaSimbolo }} {{ montoNetoRetencion }}</strong>
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <!-- <v-btn color="primary" text @click="dialog3 = false">atras</v-btn> -->
                        <v-btn color="primary" text @click="closeFactura()">atras</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :loading="loadingFactura" type="submit">Continuar</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-dialog>
        <v-dialog v-model="dialogError" max-width="400px">
            <v-card>
                <v-card-title class="grey lighten-3">
                    <h6>{{ labelDialog }}</h6>
                </v-card-title>
                <v-card-actions>
                    <v-btn color="primary" text @click="dialogError = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog4" max-width="400px" persistent>
            <v-card>
                <v-card-title class="grey lighten-3">
                    <h6>Escoga el formato deseado</h6>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-card class="d-flex justify-space-around mb-6" flat tile>
                                <v-card class="pa-3" outlined tile color="white">
                                    <v-btn color="blue" class="white--text" :loading="loadingFactura" @click="printDocument(1)">A4</v-btn>
                                </v-card>
                                <v-card class="pa-3" outlined tile color="white">
                                    <v-btn color="blue" class="white--text" type="submit" :loading="loadingFactura" @click="printDocument(2)">TICKET</v-btn>
                                </v-card>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" text @click="closePrintFactura()">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Comprobantes de la venta: una venta puede tener varias facturas. -->
        <v-dialog v-model="dialogComprobantes" max-width="420px">
            <v-card>
                <v-card-title class="grey lighten-3">
                    <h6>Comprobantes de la venta</h6>
                </v-card-title>
                <v-card-text>
                    <v-row v-for="factura in comprobantesVenta" :key="factura.numero" dense align="center" class="mb-1">
                        <v-col cols="5">
                            <span class="font-weight-medium">{{ factura.numero }}</span>
                        </v-col>
                        <v-col cols="7" class="text-right">
                            <v-btn x-small text color="primary" @click="windowOpen(factura.url)">A4</v-btn>
                            <v-btn x-small text color="primary" @click="windowOpen(`${factura.url}/ticket`)">Ticket</v-btn>
                        </v-col>
                    </v-row>
                    <div v-if="comprobantesVenta.length === 0" class="caption grey--text">Esta venta todavía no tiene comprobantes con PDF.</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogComprobantes = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="assignment" max-width="290">
            <v-card>
                <v-card-title class="text-h5"> </v-card-title>
                <v-card-text>
                    <h3>Asigne el Usuario de esta venta</h3>
                    <v-select clearable :items="listUsersAssign" v-model="userAssignment" item-text="nombres" item-value="id"></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="green darken-1" text @click="assignment = false"> Cancelar </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text :loading="loading2" @click="dialog5 = true"> Aceptar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog5" max-width="290">
            <v-card>
                <v-card-title class="text-h5"> Estas seguro? </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text :loading="loading2" @click="reAssignmentVenta()"> Aceptar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal Copiar a Cuba -->
        <v-dialog v-model="dialogCopiarCuba" max-width="500" persistent>
            <v-card>
                <v-card-title class="blue darken-1 white--text">
                    <v-icon color="white" class="mr-2">mdi-content-copy</v-icon>
                    Copiar venta a Cuba
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-alert v-if="itemCopiarCuba" type="info" outlined class="mb-4">
                        <div class="font-weight-bold">Venta original #{{ itemCopiarCuba.id }}</div>
                        <div>Cliente: {{ itemCopiarCuba.full_name }}</div>
                        <div>Fecha entrega Kunte: <strong>{{ formatDate(itemCopiarCuba.check_in) }}</strong></div>
                    </v-alert>

                    <v-text-field
                        v-model.number="diasAnticipacion"
                        label="Días de anticipación"
                        type="number"
                        min="1"
                        :rules="[v => v >= 1 || 'Debe ser al menos 1 día']"
                        hint="La fecha de Cuba debe ser anterior a la de Kunte"
                        persistent-hint
                        outlined
                        dense
                        prepend-icon="mdi-calendar-clock"
                        @input="calcularFechaCuba"
                    />

                    <v-text-field
                        v-model.number="descuentoPorcentaje"
                        label="Descuento Cuba (%)"
                        type="number"
                        min="0"
                        max="100"
                        :rules="[v => (v >= 0 && v <= 100) || 'Debe estar entre 0 y 100']"
                        hint="Porcentaje que Cuba cobra menos sobre el precio de Kunte"
                        persistent-hint
                        outlined
                        dense
                        prepend-icon="mdi-percent"
                        class="mt-3"
                    />

                    <v-alert
                        v-if="fechaCubaCalculada"
                        :type="fechaCubaCalculada < fechaKunte ? 'success' : 'error'"
                        outlined
                        class="mt-4 mb-0"
                    >
                        <div class="font-weight-bold">Fecha entrega Cuba: {{ formatDate(fechaCubaCalculada) }}</div>
                        <div v-if="itemCopiarCuba" class="mt-1">
                            Precio Kunte: <strong>S/. {{ itemCopiarCuba.importeTotal }}</strong> → 
                            Precio Cuba: <strong>S/. {{ formatDecimal(parseImporte(itemCopiarCuba.importeTotal) * (1 - descuentoPorcentaje / 100)) }}</strong>
                            <span class="ml-2" style="font-size: 12px; color: #666;">(-{{ descuentoPorcentaje }}%)</span>
                        </div>
                        <div v-if="fechaCubaCalculada >= fechaKunte" class="error--text">
                            La fecha de Cuba debe ser anterior a la de Kunte
                        </div>
                    </v-alert>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeCopiarCuba" :disabled="loadingCopiarCuba">
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        dark
                        :loading="loadingCopiarCuba"
                        :disabled="!fechaCubaCalculada || fechaCubaCalculada >= fechaKunte || diasAnticipacion < 1"
                        @click="confirmarCopiarCuba"
                    >
                        <v-icon left>mdi-content-copy</v-icon>
                        Crear en Cuba
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { formatNumber, ticketPDF } from '@/utils/genericUtils'
import { mixins } from '@/mixins/mixin.js'
import { mapState, mapGetters } from 'vuex'
import { format, addDays } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { montoComprobante, agregarComprobante } from '@/utils/montos'
import { construirAvisoObservado } from '@/utils/comprobanteObservado'
import {
    DETALLE_ANTICIPO,
    TEXTO_BUSQUEDA_ANTICIPO,
    resolverItemsAnticipo,
    itemAnticipoPorDefecto,
    etiquetaItemAnticipo,
    buildItemAnticipo,
    montoAnticipoNumero,
    detalleAnticipoValido,
    anticiposDeducibles,
    construirAnticiposParaFactura,
    registrarAnticipo,
    marcarDeducidos
} from '@/utils/anticipo'

export default {
    props: ['lista', 'title', 'head', 'serverTotal', 'itemsPerPage', 'search'],
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data: () => ({
        assignment: false,
        cuotas: [],
        plataformWeb: false,
        numberCuotas: 1,
        userAssignment: null,
        itemSelected: { id: null },
        loading2: false,
        idVenta: null,
        dialog2: false,
        dialog3: false,
        dialog4: false,
        dialog5: false,
        labelDialog: '',
        dialogError: false,
        linkPdf: '',
        optionDocument: 0,
        loadingFactura: false,
        // Variables para copiar a Cuba
        dialogCopiarCuba: false,
        itemCopiarCuba: null,
        diasAnticipacion: 3,
        descuentoPorcentaje: 20,
        loadingCopiarCuba: false,
        fechaKunte: null,
        fechaCubaCalculada: null,
        // Condiciones especiales de emisión (solo aplican a Factura)
        conDetraccion: false,
        conRetencion: false,
        detraccionTipo: '022',
        tipoCambioEmision: null,
        // Emisión: paso previo completo/anticipo, el ítem del anticipo resuelto del
        // catálogo del tenant y los anticipos de la venta que se pueden deducir en
        // la factura final.
        dialogTipoEmision: false,
        esEmisionAnticipo: false,
        itemsAnticipo: { producto: null, servicio: null },
        itemAnticipoSeleccionadoId: null,
        cargandoItemsAnticipo: false,
        errorItemsAnticipo: null,
        anticipoDetalle: DETALLE_ANTICIPO,
        anticipoMonto: '',
        anticiposSeleccionados: [],
        anticiposRemotos: [],
        pagosVenta: [],
        pagosSeleccionados: [],
        dialogComprobantes: false,
        comprobantesVenta: []
    }),
    computed: {
        ...mapState('utilities', ['tipoMoneda', 'tipoComprobanteFact', 'tipoFormaEntrega', 'condicionPago', 'enviarCorreo', 'tipoDetraccion']),
        ...mapState('pagos', ['external_tipoCambio']),
        ...mapState('users', ['user', 'listaUser']),
        ...mapState('ventas', ['loadingReservas', 'datos']),
        ...mapState('sedes', ['sedes', 'ubigeos']),
        ...mapGetters('users', ['optionalRole']),
        isTipoComprobante() {
            return this.itemSelected.idTipoComprobante
        },
        // Ítems de anticipo que la empresa tiene cargados: producto (NIU) y/o
        // servicio (ZZ). Se resuelven del catálogo del tenant, no de un código fijo.
        opcionesItemAnticipo() {
            return [this.itemsAnticipo.producto, this.itemsAnticipo.servicio]
                .filter((item) => !!item)
                .map((item) => ({ ...item, etiqueta: etiquetaItemAnticipo(item) }))
        },
        itemAnticipoSeleccionado() {
            return this.opcionesItemAnticipo.find((item) => item.internal_id === this.itemAnticipoSeleccionadoId) || null
        },
        monedaSimbolo() {
            return this.itemSelected.idTipoMoneda == 2 ? '$' : 'S/.'
        },
        // Tipo de cambio de la emisión (1 cuando es en soles)
        tipoCambioVenta() {
            if (this.itemSelected.idTipoMoneda != 2) return 1
            return Number(this.tipoCambioEmision) || 1
        },
        // Base de cálculo: lo mismo que muestra el diálogo como total a pagar.
        // Un montoFacturacion en 0 no es un monto real: cae a importeTotal.
        montoBaseComprobante() {
            // Anticipo: el comprobante vale el monto del anticipo.
            if (this.esEmisionAnticipo) return montoAnticipoNumero(this.anticipoMonto)
            // Factura final: al total de la venta se le descuentan los anticipos elegidos.
            const total = montoComprobante(this.itemSelected)
            return Number(Math.max(total - this.totalAnticiposSeleccionados, 0).toFixed(2))
        },
        // Anticipos que la venta tiene guardados y todavía no se dedujeron.
        anticiposDisponibles() {
            const locales = this.anticiposPendientesVenta(this.itemSelected)
            const porNumero = new Map(locales.map((x) => [x.numero, x]))
            this.anticiposRemotos.forEach((x) => {
                if (x && x.numero && !porNumero.has(x.numero)) {
                    porNumero.set(x.numero, { ...x, deducido: false })
                }
            })
            return [...porNumero.values()]
        },
        totalAnticiposPendientes() {
            return this.anticiposDisponibles.reduce((sum, x) => sum + Number(x.total || 0), 0)
        },
        totalAnticiposSeleccionados() {
            const elegidos = this.anticiposDisponibles.filter((x) => this.anticiposSeleccionados.includes(x.numero))
            return elegidos.reduce((sum, x) => sum + Number(x.total || 0), 0)
        },
        // Equivalente en soles: la detracción se deposita siempre en soles
        montoBaseEnSoles() {
            return this.montoBaseComprobante * this.tipoCambioVenta
        },
        detraccionPorcentaje() {
            const tipo = this.tipoDetraccion.find((x) => x.id == this.detraccionTipo)
            return tipo ? tipo.porcentaje : 0
        },
        // Monto del depósito, siempre en soles (igual que la UI de facturación)
        montoDetraccion() {
            return (this.montoBaseEnSoles * (this.detraccionPorcentaje / 100)).toFixed(2)
        },
        // Saldo a pagar, en la moneda del comprobante
        montoNetoDetraccion() {
            return (this.montoBaseComprobante - Number(this.montoDetraccion) / this.tipoCambioVenta).toFixed(2)
        },
        // Referencial: el monto real lo calcula ms-migraciones con
        // configurations.igv_retention_percentage de la sede (default 3%).
        montoRetencion() {
            return (this.montoBaseComprobante * 0.03).toFixed(2)
        },
        montoNetoRetencion() {
            return (this.montoBaseComprobante - Number(this.montoRetencion)).toFixed(2)
        },
        listUsersAssign() {
            const items = []
            this.listaUser.map((x) => {
                if (x.id_role == 2 || x.id_role == 3) {
                    items.push({ ...x })
                }
            })
            return items
        },
        headers() {
            const idBussines = this.user ? this.user['idBussines'] : 1
            let lista = [
                { text: 'Actions', value: 'action', sortable: false, bussines: [1, 2, 4, 99] },
                { text: 'ESTADO', value: 'descEstado', bussines: [1, 2, 4, 99] },
                { text: 'TICKET', value: '_id', bussines: [1, 2, 4, 99] },
                { text: 'SEDE', value: 'sedeDetail', bussines: [1, 2, 4, 99] },
                { text: 'Plataforma', value: 'web_online', bussines: [4] },
                { text: 'Vendedor', value: 'UserAssignment', bussines: [1, 2, 4, 99] },
                { text: 'Fecha Creación', value: 'fechaCreacion', bussines: [1, 2, 4, 99] },
                { text: 'Hora Venta', value: 'horaCreated', bussines: [1, 2, 4, 99] },
                { text: 'Fecha Entrega/Fin', value: 'check_in', bussines: [1, 2, 4, 99] },
                { text: 'Fecha Fin', value: '_updated_at', bussines: [1] },

                { text: 'ITEMS', value: 'maxItems', bussines: [2, 4] },
                { text: 'Description', value: '_description', bussines: [1, 2, 4, 99] },
                // Columna Proveedor deshabilitada temporalmente (solicita negocio 2/4)
                // { text: 'Proveedor', value: 'supplier_name', bussines: [2, 4] },
                { text: 'Cliente', value: '_full_name', bussines: [1, 2, 4, 99] },
                { text: 'Total a Pagar', value: 'importeTotal', filterable: false, bussines: [1, 2, 4, 99] },
                {
                    text: 'Total Pagado (S/)',
                    value: 'importeAbonadoSoles',
                    filterable: false,
                    bussines: [1, 2, 4, 99]
                },
                {
                    text: 'Total Pagado ($)',
                    value: 'importeAbonadoDolares',
                    filterable: false,
                    bussines: [2, 4]
                },
                { text: 'idCot / idOrdenCompra', value: 'cotOC', bussines: [2, 4] },
                { text: 'FormaEntrega', value: 'formaEntregaDesc', bussines: [2, 4] }
            ]

            const _lista = this.head || lista.filter((x) => x.bussines.includes(idBussines))
            //console.log('idBussines ', idBussines)
            console.log('lista', lista)
            return _lista
        },
        listUserSede() {
            const filterListUser = []
            this.listaUser.filter((x) => {
                if (x.idSede && x.isLogin == 1 && x.status == 1) {
                    filterListUser.push({ nombres: x.nombres, id: x.id })
                }
            })
            return filterListUser
        },
        _lista() {
            const items = []
            console.log('this.lista', this.lista)
            console.log('user--', this.user)
            if (this.lista.length > 0 && this.ubigeos) {
                this.lista.map((v) => {
                    const userAssignment = this.listaUser.find((x) => x.id == (v.idUserAssignment ? v.idUserAssignment : v.idColaborador))
                    let nameProduct = ''

                    const obtenerDescripcion = (elemento) => {
                        try {
                            const final = elemento && elemento.length > 0 ? (typeof elemento === 'string' ? JSON.parse(elemento)[0] : elemento[0]) : null
                            nameProduct = final ? final.name || final.description || final.descSodimac || final.rename || final.second_name || '' : ''
                        } catch (error) {
                            console.error('Error al procesar el elemento:', error)
                        }
                    }

                    const source = this.user.idBussines === 1 ? (v.privados.length > 0 ? v.privados : v.productos) : v.productos
                    obtenerDescripcion(source)
                    const firstProduct = source && source.length > 0 ? (typeof source === 'string' ? JSON.parse(source)[0] : source[0]) : null
                    const fechaCompleta = new Date(v.created_at)
                    const horaFormateada = `${fechaCompleta.getUTCHours()}:${fechaCompleta.getUTCMinutes().toString().padStart(2, '0')}`
                    console.log('v.ubigeo ', v.ubigeo)
                    const _isProvincia = v.ubigeo ? v.ubigeo : null
                    console.log('_isProvincia ', _isProvincia)
                    console.log('this.ubigeos ', this.ubigeos)

                    const ubigeo = _isProvincia ? this.ubigeos.find((w) => w.id == _isProvincia) : null
                    const nombreDist = ubigeo ? ubigeo.name : ''
                    console.log('nombreDist ', nombreDist)
                    let maxItems = 0
                    v.productos.forEach((el) => {
                        maxItems += parseInt(el.unidades, 10) || 0 // Asegura que sea un número y maneja NaN
                    })
                    const timePeriod = fechaCompleta.getUTCHours() >= 12 ? 'PM' : 'AM'
                    const fechaEstado = v.fechaEstado ? formatInTimeZone(v.fechaEstado, 'America/Lima', 'yyyy-MM-dd') : null
                    items.push({
                        ...v,
                        maxItems: maxItems,
                        anticiposPendientes: this.anticiposPendientesVenta(v).length,
                        importeTotal: formatNumber(v.importeTotal, v.idTipoMoneda),
                        efectivo: formatNumber(v.efectivo, v.idTipoMoneda),
                        tarjeta: formatNumber(v.tarjeta, v.idTipoMoneda),
                        transferencia: formatNumber(v.transferencia, v.idTipoMoneda),
                        adelanto: formatNumber(v.adelanto, v.idTipoMoneda),
                        cotOC: v.idCotizacion ? v.idCotizacion : v.idOrdenCompra,
                        oldTicket: `${v.oldTicket || ''} ${v.oldTicketReserva || ''}`,
                        _id: `T-${v.id}`,
                        _finalizado: v.finalizado == 1 ? 'F' : 'P',
                        estado: v.finalizado,
                        horaCreated: `${horaFormateada} ${timePeriod}`,
                        _full_name: v.full_name ? v.full_name.slice(0, 25) : '',
                        _description: nameProduct,
                        supplier_name: firstProduct?.supplier_name || '',
                        UserAssignment: userAssignment ? `${userAssignment.nombres} ${userAssignment.apellidos}` : 'FIORELLA CHECCLLO',
                        fechaEstado: fechaEstado,
                        formaEntregaDesc: v.formaEntrega ? `${this.tipoFormaEntrega.find((x) => x.id == v.formaEntrega)?.text} - ${nombreDist}` : null,

                        sedeDetail: this.sedes.find((x) => x.id == v.idSede)?.sede_name_id
                            ? this.sedes.find((x) => x.id == v.idSede)?.sede_name_id
                            : v.sedeDetail,
                        _updated_at: v.finalizado == 1 && v.updated_at ? formatInTimeZone(v.updated_at, 'UTC', 'yyyy-MM-dd HH:mm') : null
                    })
                })
            }
            const userOptionalRole = JSON.parse(this.user.optionalRole)
            console.log('HERE-1', this.user.id_role, userOptionalRole.newVendor)

            if (this.user.id_role == 4) {
                const filterLogistica = items.filter((x) => x.tipoEntrega != 9)
                return filterLogistica
            } else if (this.user.id_role == 6) {
                console.log('HERE-1', this.user.idSede, this.user.id_role, userOptionalRole.newVendor)

                if (userOptionalRole.newVendor) {
                    return items.filter((x) => x.idColaborador == this.user.id)
                }
                return items
            }
            return items
        }
        //JU
    },
    methods: {
        // Anticipos de la venta que todavía no se dedujeron (atributos.anticipos).
        anticiposPendientesVenta(item) {
            try {
                const attrs = (item && item.atributos) || {}
                const parsed = typeof attrs === 'string' ? JSON.parse(attrs || '{}') : attrs
                return anticiposDeducibles(parsed.anticipos)
            } catch (error) {
                console.warn('No se pudieron leer los anticipos de la venta', error)
                return []
            }
        },
        // Anticipos pendientes según facturación: cubre los emitidos fuera de la intranet.
        async cargarAnticiposRemotos(item) {
            try {
                const remotos = await this.$store.dispatch('ventas/anticiposPendientes', { id: item.id })
                if (this.itemSelected && this.itemSelected.id === item.id) {
                    this.anticiposRemotos = Array.isArray(remotos) ? remotos : []
                }
            } catch (error) {
                console.warn('No se pudieron consultar los anticipos de la venta', error)
                this.anticiposRemotos = []
            }
        },
        // Pagos de la venta que se pueden asociar a este comprobante: se preseleccionan los
        // que todavía no están asociados a otro comprobante.
        async cargarPagosVenta(item) {
            try {
                const pagos = await this.$store.dispatch('pagos/listaPagosById', { id: item.id })
                if (this.itemSelected && this.itemSelected.id === item.id) {
                    this.pagosVenta = Array.isArray(pagos) ? pagos : []
                    this.pagosSeleccionados = this.pagosVenta.filter((x) => !x.idExternal).map((x) => Number(x.id))
                }
            } catch (error) {
                console.warn('No se pudieron cargar los pagos de la venta', error)
                this.pagosVenta = []
                this.pagosSeleccionados = []
            }
        },
        etiquetaPago(pago) {
            const referencia = pago.nroOperacion || `Pago #${pago.id}`
            const asociado = pago.idExternal ? ' (ya asociado)' : ''
            return `${pago.fechaPago} — ${referencia} — ${this.monedaSimbolo} ${Number(pago.importe || 0).toFixed(2)}${asociado}`
        },
        // Comprobantes de la venta con su PDF: una venta puede tener varias facturas.
        abrirComprobantes(item) {
            let atributos = (item && item.atributos) || {}
            if (typeof atributos === 'string') {
                try {
                    atributos = JSON.parse(atributos || '{}')
                } catch (error) {
                    atributos = {}
                }
            }

            const facturas = Array.isArray(atributos.facturas) ? atributos.facturas.filter((f) => f && f.url) : []
            // Compatibilidad: ventas viejas guardaron un solo PDF en url_pdf_doc.
            const unaSola = atributos.url_pdf_doc ? [{ numero: item.numeroComprobante || '', url: atributos.url_pdf_doc }] : []
            this.comprobantesVenta = facturas.length > 0 ? facturas : unaSola
            this.dialogComprobantes = true
        },
        windowOpen(url) {
            if (!url) {
                this.$store.commit('mainUI/OPEN_MODAL', { state: true, overlay: false, color: 'red', width: '400px', text: 'No hay URL disponible para este documento', close: true })
                return
            }
            window.open(url, '_blank')
        },
        openHistorialEstado(item) {
            this.$store.commit('ventas/SHOW_MODAL_HISTORIAL_ESTADO', {
                state: true,
                idVenta: item.id
            })
        },
        async openDatosEnvio(item) {
            await this.$store.dispatch('ventas/selectReserva', item)
            this.$store.commit('ventas/SHOW_MODAL_DATOS_ENVIO', { state: true })
        },
        onTableOptions({ page, itemsPerPage }) {
            this.$emit('update:options', { page, itemsPerPage })
        },
        deleteCuota(index) {
            this.cuotas.splice(index, 1)
        },
        async deleteItem() {
            this.loading2 = true
            await this.$store.dispatch('ventas/deleteVenta', this.itemSelected)
            this.$emit('refresh')
            this.loading2 = false
            this.dialog2 = false
        },
        closeFactura() {
            this.dialog3 = false
            this.dialogTipoEmision = false
            this.esEmisionAnticipo = false
            this.anticipoDetalle = DETALLE_ANTICIPO
            this.anticipoMonto = ''
            this.anticiposSeleccionados = []
            this.cuotas = []
            this.conDetraccion = false
            this.conRetencion = false
            this.detraccionTipo = '022'
            this.tipoCambioEmision = null
        },
        // Si la venta no trae tipo de cambio y es en dólares, se trae el del día como sugerencia
        async cargarTipoCambio() {
            await this.$store.dispatch('pagos/tipoCambio')
            if (!this.tipoCambioEmision && this.external_tipoCambio) {
                this.tipoCambioEmision = Number(this.external_tipoCambio) || null
            }
        },
        // Detracción y retención solo aplican a Factura: al pasar a Boleta se limpian
        onChangeTipoComprobante() {
            if (this.itemSelected.idTipoComprobante != 1) {
                this.conDetraccion = false
                this.conRetencion = false
            }
        },
        async closePrintFactura() {
            this.dialog4 = false
            this.$emit('refresh')
            this.$root.$emit('refresh-reservas')
        },
        pushCuotas() {
            this.numberCuotas++
            const inCuotas = []
            this.cuotas.push({
                date: format(addDays(new Date(), 30), 'yyyy-MM-dd'),
                importe: 0,
                menu: false
            })
            const cantidadDeudora = this.montoBaseComprobante
            //console.log('cantidadDeudora', cantidadDeudora)
            this.cuotas.map((x) => {
                inCuotas.push({ ...x, importe: (cantidadDeudora / this.numberCuotas).toFixed(2) })
            })
            this.cuotas = inCuotas

            //console.log('cuotas', this.cuotas)
        },
        colorEstado(payload) {
            let color
            switch (payload) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 39:
                case 12:
                    color = 'green'
                    break
                case 8:
                case 13:
                    color = 'orange'
                    break
                case 9:
                case 10:
                case 11:
                case 14:
                case 42:
                    color = 'red'
                    break
            }
            return color
        },
        printReservation(item) {
            //console.log(item)
            /* this.$store.commit("ventas/UPDATE_DATOS", item); */
            this.$store.dispatch('printer/reservation', item)
        },
        openDelete(item) {
            this.dialog2 = true
            this.itemSelected = item
        },
        async sendProof(data) {
            const documento = [
                { id: 1, fileName: data.data.data.filename, url: data.data.links.pdf },
                { id: 2, fileName: data.data.data.filename, url: `${data.data.links.pdf}/ticket` }
            ]
            if (this.itemSelected.isEmailSelected != 3) {
                await this.$store.dispatch('ventas/enviarComprobante', { ...this.itemSelected, documento })
            }
        },
        async activeTicket(item) {
            let n = 0
            while (n < 2) {
                this.$store.dispatch('ventas/activarTicket', item)
                this.$emit('refresh')
                n++
            }
        },
        async printDocument(index) {
            if (!this.linkPdf) return
            try {
                if (index === 1) {
                    await window.open(this.linkPdf)
                } else {
                    await window.open(`${this.linkPdf}/ticket`)
                }
            } catch (e) {
                console.error('Error al abrir documento', e)
            }
        },
        async reAssignmentVenta() {
            this.loading2 = true
            await this.$store.dispatch('ventas/assignmentVenta', {
                idUsuario: this.userAssignment,
                idVenta: this.idVenta,
                data: this.listaUser.find((x) => x.id == this.userAssignment)
            })
            this.loading2 = false
            this.assignment = false
            this.dialog5 = false
            this.$emit('refresh')
        },
        openDialog3(item) {
            // La venta ya puede tener facturas: ahora siempre se puede emitir otra y la
            // lista de comprobantes se acumula con comas.
            const cliente = {
                identity_document_type_id: item.idTipoDocumento || '1',
                number: item.numeroDocumento || '',
                defaultName: item.full_name || ''
            }
            this.numberCuotas = 1
            this.itemSelected = item
            this.itemSelected.idUserAssignment = item.idUserAssignment
            this.itemSelected.idTipoComprobante = cliente.identity_document_type_id == '1' ? 2 : 1
            // Cada apertura arranca sin condiciones especiales y sin ítem parcial previo
            this.conDetraccion = false
            this.conRetencion = false
            this.detraccionTipo = '022'
            this.esEmisionAnticipo = false
            this.itemAnticipoSeleccionadoId = null
            this.anticipoDetalle = DETALLE_ANTICIPO
            this.anticipoMonto = ''
            this.anticiposSeleccionados = []
            // El tipo de cambio viene de la venta; en soles es 1 por definición.
            // Si es en dólares y no llega, se consulta el del día como respaldo.
            this.tipoCambioEmision = item.tipoCambio || (item.idTipoMoneda == 2 ? null : 1)
            if (item.idTipoMoneda == 2 && !this.tipoCambioEmision) {
                this.cargarTipoCambio()
            }
            this.cuotas = []
            this.anticiposRemotos = []
            this.pagosVenta = []
            this.pagosSeleccionados = []
            this.dialogTipoEmision = true
            this.cargarAnticiposRemotos(item)
            this.cargarPagosVenta(item)
        },
        // El modal de emisión reutiliza todos los campos del flujo completo: lo único
        // que cambia es el origen del total y la línea que se factura.
        elegirEmision(esAnticipo) {
            this.esEmisionAnticipo = esAnticipo
            this.anticipoDetalle = DETALLE_ANTICIPO
            this.anticipoMonto = ''
            this.anticiposSeleccionados = []
            this.numberCuotas = 1
            this.recalcularCuotas()
            this.dialogTipoEmision = false
            this.dialog3 = true
            if (esAnticipo) this.cargarItemsAnticipo()
        },
        // El ítem del anticipo es de cada empresa: se resuelve por convención contra
        // la búsqueda de productos de la sede, nunca por un código escrito acá.
        async cargarItemsAnticipo() {
            this.cargandoItemsAnticipo = true
            this.errorItemsAnticipo = null
            try {
                const idSede = this.user ? this.user.idSede : null
                if (!idSede) throw new Error('Falta la sede del usuario')

                const resultados = await this.$store.dispatch('productos/searchProductos', {
                    text: TEXTO_BUSQUEDA_ANTICIPO,
                    idSede
                })

                this.itemsAnticipo = resolverItemsAnticipo(resultados)
                const porDefecto = itemAnticipoPorDefecto(this.itemsAnticipo)
                this.itemAnticipoSeleccionadoId = porDefecto ? porDefecto.internal_id : null

                if (!porDefecto) {
                    this.errorItemsAnticipo =
                        'Esta empresa no tiene cargado el ítem de anticipo (ANTICIPO-PRODUCTO o ANTICIPO-SERVICIO)'
                }
            } catch (error) {
                this.itemsAnticipo = { producto: null, servicio: null }
                this.itemAnticipoSeleccionadoId = null
                this.errorItemsAnticipo = 'No se pudo consultar el ítem de anticipo del catálogo de la empresa'
            } finally {
                this.cargandoItemsAnticipo = false
            }
        },
        recalcularCuotas() {
            const cantidadDeudora = this.montoBaseComprobante
            this.cuotas = [{ date: format(addDays(new Date(), 30), 'yyyy-MM-dd'), importe: cantidadDeudora, menu: false }]
        },
        async comprobante() {
            try {
                this.loadingFactura = true
                if (this.esEmisionAnticipo && !detalleAnticipoValido(this.anticipoDetalle)) {
                    this.labelDialog = 'Ingrese el detalle del anticipo'
                    this.dialogError = true
                } else if (this.esEmisionAnticipo && !this.itemAnticipoSeleccionado) {
                    this.labelDialog = 'Seleccione el ítem del anticipo (producto o servicio)'
                    this.dialogError = true
                } else if (this.esEmisionAnticipo && this.montoBaseComprobante <= 0) {
                    this.labelDialog = 'Ingrese un monto mayor a 0 para el anticipo'
                    this.dialogError = true
                } else if (!this.esEmisionAnticipo && this.anticiposSeleccionados.length > 0 && this.montoBaseComprobante <= 0) {
                    // Los anticipos ya cubren la venta: no hay saldo que facturar.
                    this.labelDialog = 'Los anticipos seleccionados cubren el total de la venta: no queda saldo para facturar'
                    this.dialogError = true
                } else if (this.itemSelected.idTipoComprobante == 1 && this.itemSelected.numeroDocumento.split(' ').join('').length == 8) {
                    this.labelDialog = 'DNI NO PUEDE GENERAR FACTURA'
                    this.dialogError = true
                } else if (!this.itemSelected.full_name) {
                    this.labelDialog = 'Falta Seleccionar un Cliente'
                    this.dialogError = true
                } else if (!this.esEmisionAnticipo && !this.itemSelected.importeTotal && !this.itemSelected.montoFacturacion) {
                    this.labelDialog = 'No hay ningun costo a Pagar'
                    this.dialogError = true
                } else if (this.itemSelected.idTipoMoneda == 2 && !(Number(this.tipoCambioEmision) > 0)) {
                    this.labelDialog = 'Ingrese el tipo de cambio para emitir en dólares'
                    this.dialogError = true
                } else if (this.conDetraccion && this.conRetencion) {
                    this.labelDialog = 'No se puede aplicar detracción y retención sobre la misma operación'
                    this.dialogError = true
                } else if ((this.conDetraccion || this.conRetencion) && this.itemSelected.idTipoComprobante != 1) {
                    this.labelDialog = 'La detracción y la retención solo aplican a Factura'
                    this.dialogError = true
                } else if (this.conDetraccion && this.montoBaseEnSoles <= 700) {
                    this.labelDialog = 'Para estar sujeta a detracción, la operación debe superar los S/ 700.00 o su equivalente en dólares'
                    this.dialogError = true
                } else {
                    const cliente = {
                        id: this.itemSelected.idCliente,
                        identity_document_type_id: this.itemSelected.idTipoDocumento || '1',
                        number: this.itemSelected.numeroDocumento || '',
                        defaultName: this.itemSelected.full_name || ''
                    }
                    // El vendedor asignado puede no estar en la lista (sede o business nuevo):
                    // se cae al usuario logueado en vez de romper la emisión.
                    const findNewUser = this.listaUser.find((x) => x.id == this.itemSelected.idUserAssignment) || this.user
                    const payload = {
                        ...this.itemSelected,
                        cliente,
                        cuotas: this.cuotas,
                        userNumeroDocumento: findNewUser.documento || this.user.documento,
                        idSede: findNewUser.idSede
                    }
                    if (this.esEmisionAnticipo) {
                        // Solo viaja la línea del anticipo: los productos de la venta no se
                        // tocan y el total del comprobante es el monto del anticipo.
                        payload.esAnticipo = true
                        payload.privados = []
                        payload.productos = [
                            buildItemAnticipo({
                                detalle: this.anticipoDetalle,
                                monto: this.anticipoMonto,
                                idTipoMoneda: this.itemSelected.idTipoMoneda,
                                item: this.itemAnticipoSeleccionado
                            })
                        ]
                        payload.importeTotal = this.montoBaseComprobante
                    } else if (this.anticiposSeleccionados.length > 0) {
                        // Factura final: viajan solo los anticipos pendientes elegidos; el BFF
                        // descuenta la base, el IGV y el total a pagar.
                        payload.anticipos = construirAnticiposParaFactura(this.anticiposDisponibles, this.anticiposSeleccionados)
                    }
                    // Solo los pagos marcados viajan y se asocian a este comprobante.
                    payload.pagosSeleccionados = this.pagosSeleccionados
                    if (this.itemSelected.idTipoMoneda == 2) {
                        payload.tipoCambio = Number(this.tipoCambioEmision) || 1
                    }
                    if (this.conDetraccion) {
                        payload.conDetraccion = true
                        payload.detraccion = { codigo_tipo_detraccion: this.detraccionTipo }
                    }
                    if (this.conRetencion) {
                        payload.conRetencion = true
                    }
                    const { data } = await this.$store.dispatch('ventas/comprobante', payload)
                    if (data.codigoRespuesta == '99') {
                        this.$store.commit('mainUI/OPEN_MODAL', {
                            state: true,
                            close: true,
                            text: data.messageError
                        })
                    } else if (data.codigoRespuesta == 400 || data.codigoRespuesta == 500 || data.codigoRespuesta == '400' || data.codigoRespuesta == '500') {
                        this.cuotas = []
                        this.labelDialog = data.message || 'Error al generar el comprobante'
                        this.dialogError = true
                    } else if (data.data && data.data.data && data.data.data.id) {
                        this.cuotas = []
                        this.linkPdf = data.data.links['pdf']
                        const attrs = this.itemSelected.atributos || {}
                        const atributos = typeof attrs === 'string' ? JSON.parse(attrs || '{}') : { ...attrs }

                        // Anticipos: el emitido se registra en la venta para deducirlo después; el
                        // que se dedujo en esta factura queda marcado para no volver a ofrecerlo.
                        if (this.esEmisionAnticipo) {
                            atributos.anticipos = registrarAnticipo(atributos.anticipos, {
                                numero: data.data.data.number,
                                total: this.montoBaseComprobante,
                                fecha: data.data.data.date_of_issue || null
                            })
                        } else if (this.anticiposSeleccionados.length > 0) {
                            atributos.anticipos = marcarDeducidos(atributos.anticipos, this.anticiposSeleccionados)
                        }
                        // La venta acumula sus comprobantes: cada emisión agrega su PDF a la lista
                        // y se mantiene url_pdf_doc (el último) por compatibilidad.
                        const facturasPrevias = Array.isArray(atributos.facturas) ? atributos.facturas : []
                        const numeroNuevo = data.data.data.number
                        if (!facturasPrevias.some((f) => f.numero === numeroNuevo)) {
                            const comprobante = { numero: numeroNuevo, url: this.linkPdf, fecha: data.data.data.date_of_issue || null }
                            atributos.facturas = [...facturasPrevias, comprobante]
                        }
                        this.itemSelected.atributos = atributos

                        // El BFF ya escribio el numero acumulado (fuente autoritativa): la intranet
                        // solo lo muestra y no vuelve a escribir la columna, para no pisar un numero
                        // agregado por otra sesion. Si el BFF no lo devuelve (version anterior), se
                        // cae al calculo local.
                        const numeroComprobante = data.numeroComprobante || agregarComprobante(this.itemSelected.numeroComprobante, data.data.data.number)
                        this.itemSelected.numeroComprobante = numeroComprobante
                        await this.$store.dispatch('ventas/patchVenta', {
                            id: this.itemSelected.id,
                            atributos: { ...atributos, url_pdf_doc: this.linkPdf }
                        })
                        
                        // Also update the local datos in the store for immediate use
                        this.$store.commit('ventas/UPDATE_DATOS', { numeroComprobante: numeroComprobante })

                        // 07 Observado: SUNAT aceptó el comprobante con observaciones. Se
                        // guarda igual que un aceptado (número, PDF y pagos) para no duplicarlo
                        // en un reintento, pero la vendedora tiene que ver la observación.
                        if (data.observado) {
                            this.$store.commit('mainUI/OPEN_MODAL', {
                                state: true,
                                close: true,
                                text: construirAvisoObservado(data)
                            })
                        }

                        this.dialog4 = true
                        await this.sendProof(data)
                    } else {
                        this.cuotas = []
                        this.labelDialog = data.message || 'Error inesperado al generar el comprobante'
                        this.dialogError = true
                    }
                }
                this.loadingFactura = false
                this.dialog3 = false
            } catch (error) {
                console.log('error_comprobante', error)
                // Mostrar el mensaje controlado del BFF; nunca un objeto TypeError crudo.
                const mensajeError = (error && error.response && error.response.data && error.response.data.message) || (error && error.message) || 'Error inesperado al generar el comprobante'
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: mensajeError
                })
            }
        },
        async editItem(payload) {
            await Promise.all([this.$store.dispatch('ventas/selectReserva', payload)])
            this.$store.commit('ventas/SHOW_MODAL', { step: 2, state: true })
        },
        async reAssignment(payload) {
            this.assignment = true
            this.idVenta = payload.id
            this.userAssignment = payload.idUserAssignment
        },
        async showItem(payload) {
            await this.$store.dispatch('ventas/selectReserva', payload)
            this.$store.commit('ventas/SHOW_MODAL', {
                step: 2,
                state: true,
                showItem: true
            })
        },
        async createOrden(payload) {
            //console.log('payload ', payload)
            const pathURL = await this.$store.dispatch('reporte/reporteOrdenPedido', payload)
            //console.log('pathURL ', pathURL)
            this.pathURL = pathURL
            //this.$store.commit('ventas/SHOW_MODAL', { step: 2, state: true, showItem: true })
        },

        // Métodos para copiar a Cuba
        async openCopiarCuba(item) {
            // Verificar si ya fue copiada a Cuba
            try {
                const response = await this.$store.dispatch('ventas/verificarCopiaCuba', item.id)
                if (response.copiado) {
                    this.$store.commit('mainUI/OPEN_BAR', {
                        state: true,
                        text: `Esta venta ya fue copiada a Cuba (Venta #${response.ventaCubaId}). No se puede volver a copiar.`,
                        color: 'error',
                        timeout: 5000
                    })
                    return
                }
            } catch (error) {
                // Si hay error en la verificación, permitir continuar
                console.error('Error verificando copia:', error)
            }

            this.itemCopiarCuba = item
            this.fechaKunte = new Date(item.check_in)
            this.diasAnticipacion = 3
            this.descuentoPorcentaje = 20
            this.calcularFechaCuba()
            this.dialogCopiarCuba = true
        },
        closeCopiarCuba() {
            this.dialogCopiarCuba = false
            this.itemCopiarCuba = null
            this.fechaKunte = null
            this.fechaCubaCalculada = null
            this.diasAnticipacion = 3
            this.descuentoPorcentaje = 20
        },
        calcularFechaCuba() {
            if (!this.fechaKunte || !this.diasAnticipacion || this.diasAnticipacion < 1) {
                this.fechaCubaCalculada = null
                return
            }
            const fecha = new Date(this.fechaKunte)
            fecha.setDate(fecha.getDate() - this.diasAnticipacion)
            this.fechaCubaCalculada = fecha
        },
        formatDate(date) {
            if (!date) return ''
            const d = new Date(date)
            return d.toLocaleDateString('es-PE', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            })
        },
        parseImporte(valor) {
            if (typeof valor === 'number') return valor
            if (!valor) return 0
            // Remover "S/." y espacios, reemplazar coma por punto
            const num = String(valor).replace(/S\/\.?\s?/g, '').replace(/,/g, '').trim()
            return parseFloat(num) || 0
        },
        formatDecimal(valor) {
            return Number(valor).toFixed(2)
        },
        async confirmarCopiarCuba() {
            if (!this.itemCopiarCuba || !this.diasAnticipacion || this.diasAnticipacion < 1) return
            if (this.fechaCubaCalculada >= this.fechaKunte) return

            this.loadingCopiarCuba = true
            try {
                const result = await this.$store.dispatch('ventas/copiarVentaACuba', {
                    id: this.itemCopiarCuba.id,
                    diasAnticipacion: this.diasAnticipacion,
                    descuentoPorcentaje: this.descuentoPorcentaje
                })

                if (result.success) {
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: true,
                        text: `Venta #${result.ventaCreada.id} creada en Cuba exitosamente. Fecha de entrega: ${result.ventaCreada.check_in}`
                    })
                    this.closeCopiarCuba()
                    this.$emit('refresh')
                } else {
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: true,
                        text: result.message || 'Error al copiar la venta'
                    })
                }
            } catch (error) {
                console.error('Error al copiar a Cuba:', error)
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: error.response?.data?.error?.message || 'Error al copiar la venta a Cuba'
                })
            } finally {
                this.loadingCopiarCuba = false
            }
        }
    },
    watch: {
        async isTipoComprobante() {
            this.recalcularCuotas()
        },
        // Mientras se edita el monto del anticipo, la cuota única sigue al nuevo total.
        montoBaseComprobante(valor) {
            if (!this.esEmisionAnticipo) return
            if (this.cuotas.length > 1) return
            this.cuotas = [{ date: format(addDays(new Date(), 30), 'yyyy-MM-dd'), importe: valor, menu: false }]
        }
    },
    async mounted() {
        await this.$store.dispatch('sedes/getAllSedes')
    }
}
</script>
